// Shared metadata for payment methods UI (Provider + Admin).
import {
  Banknote, Building2, Wallet, Smartphone, Bitcoin, ArrowLeftRight, MapPin,
} from 'lucide-react';

export const METHOD_TYPES = [
  { key: 'bank_account',    label: 'Cuenta bancaria',        icon: Building2,     hint: 'Recibe depósitos directos en una cuenta bancaria.' },
  { key: 'bank_transfer',   label: 'Transferencia bancaria', icon: ArrowLeftRight, hint: 'Transferencia entre bancos / SWIFT / ACH.' },
  { key: 'office_deposit',  label: 'Depósito en oficina',    icon: MapPin,        hint: 'El cliente deposita físicamente en una oficina.' },
  { key: 'cash_pickup',     label: 'Efectivo en oficina',    icon: Banknote,      hint: 'Retiro / entrega en efectivo en una sucursal.' },
  { key: 'digital_wallet',  label: 'Billetera digital',      icon: Wallet,        hint: 'Zelle, Binance Pay, PayPal, etc.' },
  { key: 'mobile_money',    label: 'Pago móvil',             icon: Smartphone,    hint: 'Transferencia desde billetera móvil.' },
  { key: 'crypto_wallet',   label: 'Billetera cripto',       icon: Bitcoin,       hint: 'USDT-TRC20, BTC, etc.' },
];

export const METHOD_BY_KEY = Object.fromEntries(METHOD_TYPES.map((t) => [t.key, t]));

export const STATUS_OPTIONS = [
  { key: 'active', label: 'Activo',   color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  { key: 'paused', label: 'Pausado',  color: 'bg-amber-50 text-amber-700 border-amber-200' },
];

export const STATUS_BY_KEY = Object.fromEntries(STATUS_OPTIONS.map((s) => [s.key, s]));

// Per-type detail fields (what to render in the form's "Datos" section).
// Each field: { key, label, type ("text"|"number"), sensitive (hidden in safe view) }
export const DETAIL_FIELDS = {
  bank_account: [
    { key: 'bank',           label: 'Banco' },
    { key: 'holder',         label: 'Titular' },
    { key: 'account_number', label: 'Número de cuenta', sensitive: true },
    { key: 'swift',          label: 'SWIFT / BIC',      sensitive: true },
    { key: 'iban',           label: 'IBAN',             sensitive: true },
  ],
  bank_transfer: [
    { key: 'bank',           label: 'Banco' },
    { key: 'holder',         label: 'Titular' },
    { key: 'account_number', label: 'Cuenta destino', sensitive: true },
    { key: 'reference',      label: 'Referencia a usar' },
  ],
  office_deposit: [
    { key: 'office_name',    label: 'Nombre de la oficina' },
    { key: 'address',        label: 'Dirección',         sensitive: true },
    { key: 'contact_phone',  label: 'Teléfono contacto', sensitive: true },
  ],
  cash_pickup: [
    { key: 'office_name',    label: 'Nombre de la oficina' },
    { key: 'address',        label: 'Dirección',         sensitive: true },
    { key: 'contact_phone',  label: 'Teléfono contacto', sensitive: true },
  ],
  digital_wallet: [
    { key: 'provider',       label: 'Plataforma (Zelle, Binance Pay…)' },
    { key: 'wallet_id',      label: 'ID / email de wallet', sensitive: true },
    { key: 'alias',          label: 'Alias visible' },
  ],
  mobile_money: [
    { key: 'operator',       label: 'Operador (Movii, MTN…)' },
    { key: 'phone',          label: 'Teléfono destino', sensitive: true },
  ],
  crypto_wallet: [
    { key: 'network',        label: 'Red (TRC20, ERC20, BTC…)' },
    { key: 'address',        label: 'Dirección', sensitive: true },
    { key: 'memo',           label: 'Memo / Tag opcional' },
  ],
};

export const WEEKDAYS = [
  ['monday',    'Lunes'],
  ['tuesday',   'Martes'],
  ['wednesday', 'Miércoles'],
  ['thursday',  'Jueves'],
  ['friday',    'Viernes'],
  ['saturday',  'Sábado'],
  ['sunday',    'Domingo'],
];
